import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreatePopOrderAuthorizerInput,
    PopOrderAuthorizer,
    UpdatePopOrderAuthorizerInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class PopOrderAuthorizerService {
    private amplifyClient = generateClient();
    constructor() {}

    async listPopOrderAuthorizers(): Promise<PopOrderAuthorizer[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listPopOrderAuthorizers
                })
            ).data.listPopOrderAuthorizers.items;
            if (data) return data as PopOrderAuthorizer[];
        } catch (error) {
            console.error('Error finding PopOrderAuthorizer:', error);
            return null;
        }
    }

    async createPopOrderVehicle(
        input: CreatePopOrderAuthorizerInput
    ): Promise<PopOrderAuthorizer> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createPopOrderAuthorizer,
                    variables: {
                        input
                    }
                })
            ).data.createPopOrderAuthorizer;
            if (date) return date as PopOrderAuthorizer;
        } catch (error) {
            console.error('Error creating PopOrderAuthorizer:', error);
            return null;
        }
    }

    async updatePopOrderAuthorizer(
        input: UpdatePopOrderAuthorizerInput
    ): Promise<PopOrderAuthorizer> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updatePopOrderAuthorizer,
                    variables: {
                        input
                    }
                })
            ).data.updatePopOrderAuthorizer;
            if (date) return date as PopOrderAuthorizer;
        } catch (error) {
            console.error('Error updated PopOrderVehicle:', error);
            return null;
        }
    }
}
